import styled from "styled-components";

export const Wrapper = styled.div`
scroll-behavior: auto;
height: 100%;
position: relative;
min-height: 100%;
width: 100%;
top: 0;
`;